/**
 * PressImpact brand mark.
 * Concept: an amber tile emitting three concentric signal arcs from the
 * bottom-left origin — evoking press amplification and impact radiating outward.
 * Distinctive, geometric, works from 16px favicon to 180px hero.
 *
 * @param {"sm"|"md"|"lg"|"xl"} size — visual size preset
 * @param {boolean} inverse — flip arc stroke to amber-on-dark for dark mode hero
 */
export default function Logo({ size = "md", inverse = false, className = "" }) {
  const dim = { sm: 28, md: 36, lg: 44, xl: 72 }[size] ?? 36;
  const stroke = inverse ? "#FFC53D" : "#0A0A0A";
  const tile = inverse ? "#0A0A0A" : "#FFC53D";
  const strokeW = size === "xl" ? 5 : 4.5;

  return (
    <svg
      viewBox="0 0 64 64"
      width={dim}
      height={dim}
      className={className}
      role="img"
      aria-label="PressImpact"
    >
      <rect width="64" height="64" fill={tile} />
      <g fill="none" stroke={stroke} strokeWidth={strokeW} strokeLinecap="round">
        <path d="M8 56 A 18 18 0 0 1 26 38" />
        <path d="M8 56 A 30 30 0 0 1 38 26" />
        <path d="M8 56 A 42 42 0 0 1 50 14" />
      </g>
      <circle cx="8" cy="56" r="4" fill={stroke} />
    </svg>
  );
}
